import LocationConfigClient from './location-config-client';
import Transliterator from './transliterator';
import LocationFilter from './location-filter';
import LocationConfigStorage from './location-config-storage';
import MapManager from './map-manager';

export default angular
    .module('paysera.locationsMap.services', [])
    .service('locationConfigClient', LocationConfigClient)
    .service('transliterator', Transliterator)
    .service('locationFilter', LocationFilter)
    .service('locationConfigStorage', LocationConfigStorage)
    .service('mapManager', MapManager)
    .name
;
